import {
    setAddMapping,
    setBulkActionsButton,
    setCommentAdd,
    setComplaintAdd,
    setComplaintReport,
    setLogReport,
    setPowerRatingEdit,
    setPriceModification,
    setRateLimit,
    setSettlementSetup,
    setTariffSetup,
    setSessionModuleReport,
} from "../pages/Common/modulesSlice"
import userInfo from "../pages/Common/userInfo"
import {store} from "../store/store"
import {allModulePermissions} from "./permissions"

export const handleEnableModulePermissions = () => {
    const userPermissions = userInfo("permissions")
    if (userPermissions.length > 0) {
        const allPermissions = allModulePermissions
        const currentPermissions =
            userPermissions.length > 0 ? userPermissions.filter((item: any) => allPermissions.includes(item)) : []
        if (currentPermissions.includes("mapping")) {
            store.dispatch(setAddMapping({addMapping: true}))
        }
        if (currentPermissions.includes("bulk-actions")) {
            store.dispatch(setBulkActionsButton({bulkActionsButton: true}))
        }
        if (currentPermissions.includes("session-report")) {
            store.dispatch(setSessionModuleReport({sessionModuleReport: true}))
        }
        if (currentPermissions.includes("log-report")) {
            store.dispatch(setLogReport({logReport: true}))
        }
        if (currentPermissions.includes("complaint-add")) {
            store.dispatch(setComplaintAdd({complaintAddButton: true}))
        }
        if (currentPermissions.includes("comment-add")) {
            store.dispatch(setCommentAdd({commentAddButton: true}))
        }
        if (currentPermissions.includes("price-modification")) {
            store.dispatch(setPriceModification({priceModificationTab: true}))
        }
        if (currentPermissions.includes("power-rating")) {
            store.dispatch(setPowerRatingEdit({powerRatingEdit: true}))
        }
        if (currentPermissions.includes("complaint-report")) {
            store.dispatch(setComplaintReport({complaintReport: true}))
        }
        if (currentPermissions.includes("settlement-setup")) {
            store.dispatch(setSettlementSetup({settlementSetup: true}))
        }
        if (currentPermissions.includes("tariff-setup")) {
            store.dispatch(setTariffSetup({tariffSetup: true}))
        }
        if (currentPermissions.includes("rate-limit")) {
            store.dispatch(setRateLimit({rateLimit: true}))
        }
    }
}

export const handleDisableModulePermissions = () => {
    const userPermissions = userInfo("permissions")
    if (userPermissions.length > 0) {
        const allPermissions = allModulePermissions
        const currentPermissions =
            userPermissions.length > 0 ? userPermissions.filter((item: any) => allPermissions.includes(item)) : []

        if (currentPermissions.includes("mapping")) {
            store.dispatch(setAddMapping({addMapping: false}))
        }
        if (currentPermissions.includes("bulk-actions")) {
            store.dispatch(setBulkActionsButton({bulkActionsButton: false}))
        }
        if (currentPermissions.includes("session-report")) {
            store.dispatch(setSessionModuleReport({sessionModuleReport: false}))
        }
        if (currentPermissions.includes("log-report")) {
            store.dispatch(setLogReport({logReport: false}))
        }
        if (currentPermissions.includes("complaint-add")) {
            store.dispatch(setComplaintAdd({complaintAddButton: false}))
        }
        if (currentPermissions.includes("comment-add")) {
            store.dispatch(setCommentAdd({commentAddButton: false}))
        }
        if (currentPermissions.includes("price-modification")) {
            store.dispatch(setPriceModification({priceModificationTab: false}))
        }
        if (currentPermissions.includes("power-rating")) {
            store.dispatch(setPowerRatingEdit({powerRatingEdit: false}))
        }
        if (currentPermissions.includes("complaint-report")) {
            store.dispatch(setComplaintReport({complaintReport: false}))
        }
        if (currentPermissions.includes("settlement-setup")) {
            store.dispatch(setSettlementSetup({settlementSetup: false}))
        }
        if (currentPermissions.includes("tariff-setup")) {
            store.dispatch(setTariffSetup({tariffSetup: false}))
        }
        if (currentPermissions.includes("rate-limit")) {
            store.dispatch(setRateLimit({rateLimit: false}))
        }
    }
}
